import classNames from "classnames";
import React, { ReactElement } from "react";
import { userMessageContainerCSS, userMessageCSS } from "./UserMessage.styles";
import { UserMessageProps } from "./UserMessage.types";

export const UserMessage = ({
  children,
  className,
  ...rest
}: UserMessageProps): ReactElement => {
  return (
    <div className={classNames(userMessageContainerCSS, className)} {...rest}>
      <div className={classNames(userMessageCSS)}>{children}</div>
    </div>
  );
};
